import { render } from "./CapabilitiesContent.vue?vue&type=template&id=3469f1f7&scoped=true&ts=true"
import script from "./CapabilitiesContent.vue?vue&type=script&lang=ts"
export * from "./CapabilitiesContent.vue?vue&type=script&lang=ts"

import "./CapabilitiesContent.vue?vue&type=style&index=0&id=3469f1f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3469f1f7"]])

export default __exports__